module.exports = __webpack_public_path__ + "img/stock-photo_female-doctor.7ca1a9b9.png";